
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fg2tf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adb0cc76903c127972ab8194c8551a92>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1ba44476c8292ae$var$_react = $b1ba44476c8292ae$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b1ba44476c8292ae$var$_iconNew = $b1ba44476c8292ae$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b1ba44476c8292ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tasks".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/tasks
 * Usage guidance:
 * Single purpose - Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1ba44476c8292ae$var$TasksIcon = (props)=>/*#__PURE__*/ $b1ba44476c8292ae$var$_react.default.createElement($b1ba44476c8292ae$var$_iconNew.default, Object.assign({
        name: "TasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm6.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L6 8.086z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$b1ba44476c8292ae$var$TasksIcon.displayName = 'TasksIcon';
var $b1ba44476c8292ae$var$_default = module.exports.default = $b1ba44476c8292ae$var$TasksIcon;

});


//# sourceMappingURL=tasks.4c045aaa.js.map
